import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('./winter-vacation-2026-report/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/winter-vacation-2026-report',
  name: 'winter_vacation_2026_report',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026年寒假运动报告',
    ignoreLogin: true,
  },
}

export default [indexRoute]
